module.exports = __webpack_public_path__ + "media/images/menu-connect-ssp-icon-a5e4ab11b68573741f202fc7a436beca.svg";